import { Fragment } from 'react';

import OrgUnitAdminCredentialsLargeGrid from './OrgUnitAdminCredentialsLargeGrid';
import OrgUnitAdminCredentialsSmallGrid from './OrgUnitAdminCredentialsSmallGrid';

const OrgUnitAdminCredentialsGrid = ({ gridData, isLoading, onDeleteCredentialClicked }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            <p>{gridData.length === 1 ? `${gridData.length} Credential` : `${gridData.length} Credentials`}</p>
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <OrgUnitAdminCredentialsLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onDeleteCredentialClicked={onDeleteCredentialClicked}
      />
      <OrgUnitAdminCredentialsSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onDeleteCredentialClicked={onDeleteCredentialClicked}
      />
    </Fragment>
  )
};

export default OrgUnitAdminCredentialsGrid;